// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__ncALu","link":"Breadcrumbs_link__e8G6a","active":"Breadcrumbs_active__ZREV7"};